import { ChevronDownSmall, AndroidPlaceholder } from 'ui/icons';
import { pxToRem } from 'utils/convert';
import {
  notificationAndroidActionButton,
  notificationAndroidActionButtonGroup,
  notificationAttachmentAndroid,
  notificationAttachmentWrapper,
  notificationBubble,
  notificationBubbleAndroidBody,
  notificationBubbleAndroidBodyContent,
  notificationBubbleAndroidBodyContentMsg,
  notificationBubbleAndroidBodyContentMsgTitle,
  notificationBubbleAndroidBodyContentMsgTxt,
  notificationBubbleAndroidHeader,
  notificationBubbleAndroidHeaderTime,
  notificationBubbleAndroidIconWrapper,
} from './styles';
import { MAX_CHAR_LIMIT } from '../constants';
import { displayContent, OS, TemplateEditViews, truncateText } from '../../common';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { usePushPreviewContext } from '../context/PushPreviewContext';
import { usePreviewWithDataContext } from '../../context/PreviewWithDataContext';
import { PushContentDefinition } from '../../../graphql/types';

export const NotificationAndroid = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { view } = useQueryParamContext();
  const {
    messageContentBody,
    messageContentTitle,
    messageActionButtons,
    messageAttachmentUrlAndroid,
  } = usePushPreviewContext();
  const { isDataFeedDataEmpty, isUserDataEmpty } = usePreviewWithDataContext();
  const usePopulatedField =
    view === TemplateEditViews.preview && (!isDataFeedDataEmpty || !isUserDataEmpty);
  const pushData = (liveTemplate?.mediumData || {}) as PushContentDefinition;
  const title = usePopulatedField ? messageContentTitle : pushData.title || '';
  const message = usePopulatedField ? messageContentBody : pushData.message || '';
  const attachmentUrlAndroid = usePopulatedField
    ? messageAttachmentUrlAndroid
    : pushData.attachmentUrlAndroid || '';
  const actionButtons = usePopulatedField ? messageActionButtons : pushData.actionButtons || [];

  return (
    <div data-test="notification-preview-android" style={notificationBubble[OS.android]}>
      <div style={notificationBubbleAndroidHeader}>
        <div style={notificationBubbleAndroidHeaderTime}>
          <AndroidPlaceholder height={pxToRem(15)} width={pxToRem(15)} />
          <span style={notificationBubbleAndroidIconWrapper}>
            {displayContent.strAppName} &bull; {displayContent.strNow} <ChevronDownSmall />
          </span>
        </div>
      </div>
      <div style={notificationBubbleAndroidBody}>
        <div style={notificationBubbleAndroidBodyContent}>
          <div style={notificationBubbleAndroidBodyContentMsgTitle}>{title}</div>
          <div style={notificationBubbleAndroidBodyContentMsg}>
            {/* SMS, Push, & WebPush do not support HTML, so do not use
             * dangerouslySetInnerHTML attr to display content (force text rendering)
             * Email & InApp DO support HTML and should be displayed with
             * dangerouslySetInnerHTML={{ __html: removeScript(content) }} so that HTML
             * renders and scripts are removed prior to rendering
             */}
            <div style={notificationBubbleAndroidBodyContentMsgTxt}>
              {truncateText(message, MAX_CHAR_LIMIT.android)}
            </div>
          </div>
        </div>
        {pushData.attachmentUrlAndroid && (
          <div style={notificationAttachmentWrapper}>
            <img
              style={notificationAttachmentAndroid}
              src={attachmentUrlAndroid}
              alt="Android Push Image"
            />
          </div>
        )}
      </div>
      {actionButtons && actionButtons.length > 0 && (
        <div style={notificationAndroidActionButtonGroup}>
          {actionButtons.map((button, i) => (
            <div key={i} style={notificationAndroidActionButton}>
              {button.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
